import Button from "@vfuk/core-button/dist/Button";
import { ReactNode } from "react";
import classes from "../DeactivateUserWarningModalContent/DeactivateUserWarningModalContent.scss";
import "@ucchub/ui/src/assets/styles/common.scss";
import Spacing from "@vfuk/core-spacing";
import SimpleGrid from "@vfuk/core-simple-grid";
import Icon from "@vfuk/core-icon";

export type DeactivateUserWarningModalContentProps = {
  heading: string;
  message: string;
  body: string | ReactNode;
  confirmText: string;
  onConfirm: () => void;
  cancelMessage: string;
  onCancel: () => void;
  loading?: boolean;
  onClose?: () => void;
};

const DeactivateUserWarningModalContent = ({
  heading,
  message,
  body,
  confirmText,
  onConfirm,
  cancelMessage,
  onCancel,
  loading,
}: DeactivateUserWarningModalContentProps): JSX.Element => {
  return (
    <>
      <div className={classes.ConfirmModalContents} role="dialog">
        <div className="modalHeading">{heading}</div>

        <Spacing spacingLevel={{ top: 2, left: 12, bottom: 2 }}>
          <SimpleGrid
            columns={{
              sm: 1,
              md: 3,
            }}
            spacing={11}
            justify={"center"}
          >
            <Icon name="warn" group="state" size={5} />
          </SimpleGrid>
        </Spacing>

        <Spacing spacingLevel={{ top: 4, left: 7, right: 7 }}>
          <div className="modalMessage">{message}</div>
        </Spacing>
        <Spacing spacingLevel={{ top: 4, left: 7, right: 7, bottom: 7 }}>
          <div className="modalSubmessage">{body}</div>
        </Spacing>
        <Spacing spacingLevel={{ top: 4, left: 7, right: 7 }}>
          <SimpleGrid
            columns={{
              sm: 1,
              md: 2,
            }}
            spacing={3}
            justify={"center"}
          >
            <Button
              width="full"
              appearance="alt1"
              text={cancelMessage}
              onClick={onCancel}
            />
            <Button
              width="full"
              text={confirmText}
              onClick={onConfirm}
              loading={loading}
            />
          </SimpleGrid>
        </Spacing>
      </div>
    </>
  );
};

export default DeactivateUserWarningModalContent;
